<template>
	<div class="form-group">
		<label v-if="name && hideName === false" class="control-label" :for="uniqueId"> {{ $t('label.' + name) }} <small v-if="crequired">*</small></label>
		<div>
			<input
				type="text"
				class="form-control"
				:class="{'is-danger': errors.length > 0}"
				:id="uniqueId"
				v-model="inputFieldValue"
				:placeholder="cplaceholder"
				style="padding: 2px 0; width: 100%"
				@keyup.enter="internalValue = filteredResults[0]">
			<div class="autocompletions-box card" :class="{'expanded': this.autocompleting}">
				<a v-for="(result, i) in filteredResults" class="completion" :class="{highlighted: i == 0}" @click="internalValue = result">
					<c-avatar :family="result" :link="false"></c-avatar> {{result.name}}
				</a>
				<div class="text-muted text-center font-italic" v-if="cache.requestRunning">
					(...)
				</div>
				<div class="text-muted text-center font-italic" v-else-if="cache.results.length === 0 && autocompleteStub !== ''">
					(няма резултати)
				</div>
			</div>
			<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
		</div>
	</div>
</template>

<script>

module.exports = {
	name: 'f-family',
	props: {
		value: {type: null, default: undefined},
		name: {type: String},
		hideName: {type: null, default: false},
		cplaceholder: {type: String, default: ''},
		crequired: {type: Boolean, default: false},
		csingle: {type: Boolean, default: false},
		errors: {type: Array, default: () => ([])}
	},
	data: () => ({
		uniqueId: 'input-' + Math.random().toString(16).slice(2),
		cache: {
			fetchedFor: '',
			results: [],
			requestRunning: false
		},
		cacheResults: 10,
		autocompleteStub: '',
		autocompleting: false
	}),
	methods: {
		fetchResults () {
			if (this.autocompleteStub === '') {
				this.cache.results = this.value && !this.autocompleting ? [this.value] : [];
				this.fetchedFor = this.autocompleteStub;
				return;
			}
			if (this.cache.requestRunning) return;
			var searchingFor = this.autocompleteStub;
			this.cache.requestRunning = true;
			this.$http.get('backend://family?limit=' + this.cacheResults + '&name=' + searchingFor).then((response) => {
				this.cache.requestRunning = false;
				this.cache.results = response.body.items;
				this.fetchedFor = searchingFor;
			}).catch(this.$http.toastCatcher);
		}
	},
	watch: {
		autocompleteStub () {
			this.fetchResults();
		},
		autocompleting () {
			this.fetchResults();
		}
	},
	computed: {
		inputFieldValue: {
			get () {
				return this.autocompleting ? this.autocompleteStub : (this.value ? this.value.name : '');
			},
			set (value) {
				this.autocompleteStub = value;
				this.autocompleting = true;
			}
		},
		internalValue: {
			get () {
				return this.value;
			},
			set (value) {
				this.autocompleteStub = '';
				this.autocompleting = false;
				this.$emit('input', value);
			}
		},
		filteredResults () {
			if (this.autocompleteStub.toLowerCase().indexOf(this.cache.fetchedFor.toLowerCase()) === -1) {
				this.fetchResults();
				return [];
			} else {
				return this.cache.results.filter((x) => x.name.toLowerCase().indexOf(this.autocompleteStub.toLowerCase()) !== -1);
			}
		}
	}
};
</script>

<style media="screen">
.autocompletions-box {
	display: none;
	position: absolute;
	/*border: 1px solid rgb(83, 83, 83);*/
	/*background-color: white;*/
	z-index: 10;
	padding: 10px;
	min-width: 15rem;
	overflow: hidden;
	width: 100%;
	top: 100%;
	left: 0;
}
.autocompletions-box.expanded {
	display: block;
}
.completion {
	display: block;
}
.completion.highlighted {
	background-color: rgb(235, 233, 233);
}
.completion:hover {
	background-color: rgb(198, 198, 198);
}
</style>



// WEBPACK FOOTER //
// f-family.vue?5aacf1e2